/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Reason_Accredited_TitleInputs */



/**
* | output |
* | --- |
* | "Accredited and certified" |
*
* @param {Home_Reason_Accredited_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_reason_accredited_title = /** @type {((inputs?: Home_Reason_Accredited_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Reason_Accredited_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("认证与资质")
	return /** @type {LocalizedString} */ ("Accredited and certified")
});